import axios from 'axios';
import { DropdownItem, DropdownMenu } from "react-bootstrap";
import Toast from 'react-bootstrap/Toast';
import toast from 'react-hot-toast';
import aws from '../../assets/img/cloud/aws.svg';
import google from '../../assets/img/cloud/google.svg';
import python from '../../assets/img/cloud/python.svg';
import StorageService from '../../services/api/Storage';
import { apps } from './CommonMessages';

import StorageConfigService from '../../services/api/storageConfig';
import { cloudTypes, COOKIE_CONSENT_KEY, csv, defaultIcon, DF_TINY_URL, image, ipynb, STORAGE_DEFAULT_MOUNT_PATH, STORAGE_EXTERNAL_MOUNT_PATH } from "./constants";

// svg image for services
import UtilService from "../../services/api/Utils";
import flataws from "./../../assets/img/aws.svg";
import flatazure from "./../../assets/img/azure.svg";
import flatpy from "./../../assets/img/flatpy.svg";
import flatgoogle from "./../../assets/img/gcloud.svg";
import defaultimg from "./../../assets/img/logo_icon.png";
import spark from "./../../assets/img/spark.svg";

// Extensions
import csvFile from "../../assets/img/extensions/csv.png";
import docx from "../../assets/img/extensions/docx.png";
import jpeg from "../../assets/img/extensions/jpeg.png";
import jpg from "../../assets/img/extensions/jpg.png";
import json from "../../assets/img/extensions/json.png";
import mp3 from "../../assets/img/extensions/mp3.png";
import pdf from "../../assets/img/extensions/pdf.png";
import png from "../../assets/img/extensions/png.png";
import py from "../../assets/img/extensions/python.png";
import rar from "../../assets/img/extensions/rar.png";
import svg from "../../assets/img/extensions/svg.png";
import txt from "../../assets/img/extensions/txt.png";
import xls from "../../assets/img/extensions/xls.png";
import zip from "../../assets/img/extensions/zip.png";

const screenSize = {
    fromLarge: 1530,
    toLarge: 1300,
    fromMedium: 1301,
    toMedium: 990,
    small: 991
}

export const provisionerTypeLogo = (type) => {
    const lowerType = type?.toLowerCase() || '';
    switch (lowerType) {
        case cloudTypes.AMAZON.toLowerCase():
        case cloudTypes.AWS.toLowerCase():
            return flataws;
        case cloudTypes.GOOGLE.toLowerCase():
            return flatgoogle;
        case cloudTypes.AZURE.toLowerCase():
        case cloudTypes.AZURE_VM.toLowerCase():
            return flatazure;
        case cloudTypes.PYTHON.toLowerCase():
            return flatpy;
        case cloudTypes.SPARK.toLowerCase():
            return spark;
        default:
            return defaultimg;
    }
};

export const checkZipExtension = (fileName) => {
    if (fileName) {
        const validExtensions = ["zip", "tar", "rar", "gz"];
        const fileExtension = fileName.split('.').pop().toLowerCase();
        return validExtensions.includes(fileExtension);
    }
    return false;
};

export const CheckIsValidDomain = (domain) => {
    const re = /^((?:[\w.-]+)\.(?:[A-Za-z]{2,}))$/;
    return re.test(domain);
};
  

export const cloudAndRuntimeIcon = (type) => {
    type = type.toLowerCase()
    switch (type) {
        case "aws":
            return aws;

        case "google":
            return google;

        case "python":
            return python;

        default:
            break;
    }
}


export const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}
/**
 * 
 * @param {info, error, success, warning} type
 * @param {msg String} content 
 * @param {number} duration
 */
export const showNotification = (type, content, duration) => {
    return <Toast>
        <Toast.Header closeButton={false}>
            <strong className="me-auto">Bootstrap</strong>
            <small>11 mins ago</small>
        </Toast.Header>
        <Toast.Body>Hello, world! This is a toast message.</Toast.Body>
    </Toast>
}

export const convertTextToTitleCase = (defaultText) => {
    if (defaultText) {
        let camelCaseText = defaultText
            .split(' ')
            .map(function (word, index) {
                // First character upper case else lower case
                return word.charAt(0)
                    .toUpperCase() + word.slice(1)
                        .toLowerCase();
            })
            .join(' ');
        let fineText = camelCaseText.replace(/_/g, " ");
        return fineText;
    }
    return defaultText
};


export const getServiceList = (data) => {
    let color = ["#6495ED", "#9FE2BF", "#CCCCFF"]
    return data?.map((service, index) => (
        <div className='d-flex flex-column'><span className='badge-common' style={{
            backgroundColor: color[index]
        }} key={index} color={color[index]}>
            {service}
        </span>
        </div>
    )) || [];
};

export const logoutAndPreserveConsent = () => {  
    Object.keys(localStorage).forEach((key) => {
      if (key !== COOKIE_CONSENT_KEY) {
        localStorage.removeItem(key);
      }
    });
    sessionStorage.clear();
    window.location.href = "/auth/login";
  };  

export const constructPreviewUrls = (url, id) => {
    if (id) {
        url = url?.replace('%s', id);
    }
    return url;
};

export const constructCodeSyncUrls = (url, id) => {
    if (id) {
        url = url.replace('%s', id);
    }
    return url;
};


export const checkIfEmptyorNot = (list) => {
    if (list && list.length > 0) {
        for (let item of list) {
            return Object.entries(item)
                .filter(([key]) => key !== "title")
                .map(([, value]) => value)
                .every(val => !val);
        }
    } else {
        return true;
    }
}


const statusClasses = {
    PENDING: { badge: 'badge-pending', text: 'pending', icon: "fa-regular fa-clock", bg: "app-pending-badge" },
    CREATING: { badge: 'badge-success', text: 'success', icon: "fa-solid fa-circle-notch fa-spin", bg: "app-success-badge" },
    CREATED: { badge: 'badge-completed', text: 'success', icon: "fa-regular fa-circle-check", bg: "app-completed-badge" },
    CONFIGURED: { badge: 'badge-completed', text: 'created', icon: "fa-regular fa-circle-check", bg: "app-completed-badge" },
    FAILED: { badge: 'badge-failed', text: 'failed', icon: "fa-solid fa-triangle-exclamation", bg: "app-failed-badge" },
};

export const getAppStatusClass = (status, type = 'badge') => {
    const statusInfo = statusClasses[status];
    return statusInfo ? statusInfo[type] : undefined;
};

export const getInitialName = (name) => {
    if (name) {
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
        let initials = [...name.matchAll(rgx)] || [];
        initials = (
            (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();
        return initials
    }
}

export const checkSpecialChar = (name) => {
    if (name) {
        var regex = /^[A-Za-z0-9 _-]+$/;
        var isAlpha = !/[^a-zA-Z]/.test(name.charAt(0));
        var isValid = regex.test(name);
        if (isAlpha) {
            if (!isValid) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
};

export const getYear = () => {
    return new Date().getFullYear()
}

export const formatBytes = (bytes) => {
    var marker = 1024; // Change to 1000 if required
    var decimal = 3; // Change as required
    var kiloBytes = marker; // One Kilobyte is 1024 bytes
    var megaBytes = marker * marker; // One MB is 1024 KB
    var gigaBytes = marker * marker * marker; // One GB is 1024 MB

    // return bytes if less than a KB
    if (bytes < kiloBytes) return bytes + " Bytes";
    // return KB if less than a MB
    else if (bytes < megaBytes) return (bytes / kiloBytes).toFixed(decimal) + " KB";
    // return MB if less than a GB
    else if (bytes < gigaBytes) return (bytes / megaBytes).toFixed(decimal) + " MB";
    // return GB if less than a TB
    else return (bytes / gigaBytes).toFixed(decimal) + " GB";
}

export const downloadApp = async (fileName, storageId, rootFolder) => {
    StorageService.downloadAppObjectUrl(
        fileName,
        storageId,
        rootFolder
    )
        .then((response) => {
            downloadLink(response, fileName)
        })
        .catch((error) => {
            toast.error(apps.failedDownload)
        });
}

export const downloadVersionApp = async (fileName, versionName, storageId, rootFolder) => {
    StorageService.downloadVersionObjectUrl(
        fileName,
        versionName,
        storageId,
        rootFolder
    )
        .then((response) => {
            downloadLink(response, versionName)
        })
        .catch((error) => {
            toast.error(apps.failedDownload)
        });
}

const downloadLink = (response, fileName) => {
    if (!response?.download_url) {
        toast.error("Invalid response: download_url not found.");
        return;
    }
    if (!fileName) {
        toast.error("Invalid file name.");
        return;
    }
    axios.get(response?.download_url, { responseType: 'blob' })
        .then((res) => {
            const blob = new Blob([res.data], { type: res.headers['content-type'], encoding: 'UTF-8' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${fileName}.zip`;
            link.click();
        }).catch(err => {
            console.log(err);
        });
};


export const getImageFile = (ext) => {
    if (ext === "csv") {
        return csv;
    }
    else if (ext === "ipynb" || ext === "py" || ext === "log") {
        return ipynb;
    }
    else if (ext === "jpeg" || ext === "jpg" || ext === "png" || ext === "svg") {
        return image;
    } else {
        return defaultIcon;
    }
}

export const imageFileExtension = (fileName) => {
    let ext = "";
    if (fileName !== null && fileName !== undefined) {
        ext = fileName.split('.').pop();
    }
    return ext;
}

const truncateFile = (text, len) => {
    if (text !== undefined && len !== undefined) {
        let first = "";
        let last = "";
        var path = text.substring(0, text.lastIndexOf("/") + 1);
        var fileName = text.split('/').pop();
        if (path !== undefined && path.length >= len) {
            first = path.substring(0, len - 3) + ".../"
        } else {
            if (path === "/") {
                path = "";
            }
            first = path.substring(0, path.length)
        }

        if (fileName !== "" && fileName.length >= len) {
            last = "..." + fileName.slice(-len)
        } else {
            last = fileName.substring(0, fileName.length)
        }

        if (last === "") {
            first = first.substring(0, first.lastIndexOf("/"));
        }
        return first + last;
    }
}

export const truncateEllipsis = (text) => {
    if (window.screen.width <= screenSize.fromLarge && window.screen.width >= screenSize.toLarge) {
        return truncateFile(text, 30)
    } else if (window.screen.width <= screenSize.fromMedium && window.screen.width >= screenSize.toMedium) {
        return truncateFile(text, 15)
    } else if (window.screen.width <= screenSize.small) {
        return truncateFile(text, 30)
    } else {
        return truncateFile(text, 25)
    }
}

export const getStorageId = () => {
    StorageConfigService.getAllStorageConfig()
        .then((response) => {
            if (response?.status === 'SUCCESS') {
                let configData = [];
                configData = response.storageDTOPage.content
                let platformDefault = getPlatformDefaultInfo(configData);
                if (platformDefault !== null && platformDefault !== undefined) {
                    return platformDefault.id
                }
            } else {
                return null;
            }
        }
        );
}

const getPlatformDefaultInfo = (data) => {
    let platformDefault = data.filter(item => item.platformDefault);
    if (platformDefault.length > 0) {
        return platformDefault[0];
    }
}

/**
 * Generate new UUID string
 */
export const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}

export const fileSizeSI = (a, b, c, d, e) => {
    return (b = Math, c = b.log, d = 1e3, e = c(a) / c(d) | 0, a / b.pow(d, e)).toFixed(2)
        + ' ' + (e ? 'kMGTPEZY'[--e] + 'B' : 'bytes')
}

const getLastPath = (str) => {
    var splitByValues = str.split("/")
    var lastName = splitByValues[splitByValues.length - 2]
    return lastName
}

export const duplicateFilePath = (pageArray, lastName, isDirectory) => {
    for (let i = 1; i <= 10; i++) {
      let newName = `Copy_of_${i}_${lastName}`;
      let filteredPaths = [];
  
      if (isDirectory) {
        filteredPaths = pageArray.filter(
          item => getLastPath(item).toLowerCase() === newName.toLowerCase()
        );
      } else {
        filteredPaths = pageArray.filter(
          item => item.name.split("/").pop().toLowerCase() === newName.toLowerCase()
        );
      }
  
      if (filteredPaths.length === 0) {
        return newName;
      }
    }
  };
  

export const getActualPath = (redirectUrl) => {
    let copyMsg = "Shareable link Copied";
    if (redirectUrl !== null && redirectUrl !== undefined) {
        var tempInput = document.createElement("input");
        tempInput.value = redirectUrl;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        toast.success(copyMsg);
    }
}

export const generateTinyUrl = async (originalUrl) => {
    axios.get(DF_TINY_URL + encodeURIComponent(originalUrl))
        .then(response => {
            if (response.status === 200) {
                getActualPath(response.data);
            } else {
                getActualPath(originalUrl);
            }
        })
        .catch(error => {
            getActualPath(originalUrl);
        });
};

export const extensions = (format) => {
    switch (true) {
        case !format:
            return txt;
        case format.startsWith('audio/'):
            return mp3;
        case format.startsWith('image/'):
            return jpeg;
        case format.endsWith('csv'):
            return csvFile;
        case format.startsWith('text/'):
            return txt;
        case format.endsWith('pdf'):
            return pdf;
        case format.endsWith('xlsx'):
            return xls;
        case format.endsWith('zip'):
            return zip;
        case format.endsWith('rar'):
            return rar;
        case format.endsWith('less'):
            return json;
        case format.endsWith('docx'):
            return docx;
        case format.endsWith('jpeg'):
            return jpeg;
        case format.endsWith('jpg'):
            return jpg;
        case format.endsWith('png'):
            return png;
        case format.endsWith('svg'):
            return svg;
        case format.endsWith('ipynb') ||
            format.endsWith('py') ||
            format.endsWith('npy'):
            return py;
        case format.endsWith('json'):
            return json;
        default:
            return txt;
    }
}

export const findIcon = (contentType) => {
    switch (true) {
        case !contentType:
            return 'https://docs.webix.com/docmanager-backend/icons/small/code/txt.svg';
        case contentType.startsWith('audio/'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/audio/mp3.svg';
        case contentType.startsWith('image/'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/image/JPG.svg';
        case contentType.endsWith('csv'):
            return 'https://docs.webix.com/filemanager-backend/icons/small/document/csv.svg'
        case contentType.startsWith('text/'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/code/txt.svg';
        case contentType.endsWith('pdf'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/document/pdf.svg';
        case contentType.endsWith('xlsx'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/document/xlsx.svg';
        case contentType.endsWith('zip'):
            return 'https://docs.webix.com/filemanager-backend/icons/small/archive/zip.svg';
        case contentType.endsWith('rar'):
            return 'https://docs.webix.com/filemanager-backend/icons/small/archive/rar.svg';
        case contentType.endsWith('less'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/code/less.svg';
        case contentType.endsWith('docx'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/document/docx.svg';
        case contentType.endsWith('jpeg') ||
            contentType.endsWith('png') ||
            contentType.endsWith('svg') ||
            contentType.endsWith('jpg'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/document/image.svg';
        case contentType.endsWith('ipynb') ||
            contentType.endsWith('py') ||
            contentType.endsWith('npy') ||
            contentType.endsWith('json'):
            return 'https://docs.webix.com/docmanager-backend/icons/small/code/py.svg';
        default:
            return 'https://docs.webix.com/docmanager-backend/icons/small/code/txt.svg';
    }
}

export const CSVToJSONs = (csv) => {
    const [headerLine, ...lines] = csv.trim().split('\n');
    const headers = headerLine.split(',');
  
    return lines.map((line) => {
      const values = [];
      let current = '';
      let inQuotes = false;
  
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
  
        if (char === '"' && line[i + 1] === '"') {
          current += '"';
          i++;
        } else if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          values.push(current);
          current = '';
        } else {
          current += char;
        }
      }
      values.push(current);
  
      const obj = {};
      headers.forEach((header, i) => {
        obj[header.trim()] = values[i] ? values[i].trim() : '';
      });
  
      return obj;
    });
  }
  

export const checkIsTitleUnique = (list) => {
    const duplicate = [];
    if(list){
        const titleCount = {};
        list?.forEach(item => {
            const title = item?.title;
            titleCount[title] = (titleCount[title] || 0) + 1;
        });
    
        for (let item in titleCount) {
            if (titleCount[item] > 1) {
                duplicate.push(item)
            }
        }
        return duplicate
        // let duplicate = duplicate && duplicate?.length > 0 ? true : false;
    }
    return duplicate;
}

async function getAllStorageConfig() {
    try {
      const response = await StorageConfigService.getAllStorageConfig();
      if (response?.status === 'SUCCESS') {
        return response.storageDTOPage.content;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }

  const getStorageType = (filePath, storageId, root, configData) => {
    let constructFilePath = filePath;
    if (configData !== undefined && configData !== null) {
        if (storageId === null) {
            constructFilePath = STORAGE_DEFAULT_MOUNT_PATH + constructFilePath;
            return constructFilePath;
        }
        let filterArray = configData.filter(item => item.id === storageId);
        if (filterArray.length > 0) {
            let platformDefault = filterArray[0].platformDefault
            constructFilePath = platformDefault ? STORAGE_DEFAULT_MOUNT_PATH + constructFilePath :
                STORAGE_EXTERNAL_MOUNT_PATH + filterArray[0].name + "/" + root + "/" + constructFilePath;
            return constructFilePath;
        }
    }
    return constructFilePath;
  }
  
const openExtractFileView = (name, fromLocation, storageId, root) => {
    // let reg = fromLocation === "projectRuns" ? "/extract-view" : "/extract";
    let reg = "/extract";
    let currentUrl = window.location.href;
    let path = name.slice(-1) === "/" ? "/storage?path=" + name : "/storageView?file=" + name; 
    if (storageId !== null && storageId !== undefined && storageId !== "") {
      path = name.slice(-1) === "/" ? "/storage?path=" + name : "/storageView?file=" + name + "&storage=" + storageId + "&root=" + root; 
    }
    let redirectUrl = currentUrl.replace(reg, path);
    window.open(redirectUrl, "_blank");
  }

  export const onExtractSplitView = (inputFile, storageId, outputFile, fromLocation) => {
    let currentUrl = window.location.href;
    let reg = fromLocation === "projectRuns" ? "/extract-view" : "/extract";
    let replaceUrl = "/splitView?filePath=" + inputFile + "&storageId=" + storageId + "&outputFile=" + outputFile;
    let redirectUrl = currentUrl.replace(reg, replaceUrl)
    window.open(redirectUrl, "_blank");
  }

  // Download particular file in input or code
export const downloadparticularFiles = (fileName, sId, rootFolder) => {
StorageService.downloadObjectUrl(fileName, sId, rootFolder)
  .then((response) => {
    const link = document.createElement('a');
    link.href = response.download_url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}

export const onCopyPath = async (item, sId, root, event) => {
try {
  let configData = await getAllStorageConfig();
  let path = getStorageType(item, sId, root, configData);
  if (path !== undefined) {
    var filepath = document.createElement('textarea')
    filepath.innerText = path
    document.body.appendChild(filepath)
    filepath.select()
    document.execCommand('copy')
    filepath.remove()
    toast.success( <b className="toast-txt">Copied</b>);
  }
} catch (error) {
}
};

  const GetLink = (name, storageId, rootFolder, event) => {
        let isDirectory = name ? false : true
        localStorage.setItem("filePathStorage", name);
        let currentUrl = window.location.href;
        let reg = "/extract" + window.location.search;
        let redirectUrl = "";
        if (!isDirectory) {
            redirectUrl = currentUrl.replace(reg, "/storageView?storage=" + storageId + "&root=" + rootFolder + "&file=" + name);
        } else {
            redirectUrl = currentUrl.replace(reg, "/storage?storage=" + storageId + "&root=" + rootFolder + "&path=" + name);
        }
        generateTinyUrl(redirectUrl)
    }

export const getAllLLMs = async () => {
    try {
        const llms = await UtilService.getLLMList();
        return llms;
    } catch (error) {
        console.error('Failed to get LLM list:', error);
        return [];
    }
};

export const getAllHandler = async () => {
    try {
        const handlers = await UtilService.getHandlers();
        return handlers;
    } catch (error) {
        console.error('Failed to get handlers:', error);
        return [];
    }
};
    

export const constructMenus = (fileName,outputFile, storageId, root, location) => {
        return <DropdownMenu className="font13">
                <DropdownItem  onClick={() => openExtractFileView(fileName, location, storageId, root)}>
                    <span><i className="fas fa-binoculars me-2 text-primary"></i>View</span>
                </DropdownItem>
                {/* {fileName.toString().toLowerCase().includes(".pdf") &&
      <DropdownItem className="dropdown_normal"
      onClick={() =>{onExtractSplitView(fileName, storageId, outputFile, location)}}
      >        <i className="fas fa-solid fa-arrows-split-up-and-left mr-1 df-text-primary" /> Split View
      </DropdownItem>}  */}
      <DropdownItem className="dropdown_normal" onClick={() => downloadparticularFiles(fileName)} >
        <i className="fas fa-download mr-1 text-primary" /> Download
      </DropdownItem>
    <DropdownItem className="dropdown_normal" onClick={e => onCopyPath(fileName, e.domEvent)}>
      <i className="fa-solid fa-clipboard mr-1 text-primary" /> Copy Path
    </DropdownItem>
    <DropdownItem className="dropdown_normal" onClick={e => { GetLink(fileName,storageId, root, e.domEvent) }}>
      <i className="fas fa-link mr-1 text-primary" /> Get Sharable Link
    </DropdownItem>
        </DropdownMenu>
    }
      
// ----------------------------------------------------------------------
// 🔍 Find component by data-component-id
// ----------------------------------------------------------------------
export const findComponentById = (files, componentId) => {
    const pattern = new RegExp(
        `<[^>]*data-component-id=["']${componentId}["'][^>]*>([\\s\\S]*?)<\\/[^>]+>|<[^>]*data-component-id=["']${componentId}["'][^>]*/>`,
        'i'
    );

    for (const file of files) {
        const match = file.contents.match(pattern);
        if (match) {
            return {
                name: file.name,
                contents: match.input.trim()
            };
        }
    }

    return null;
}


// ----------------------------------------------------------------------
// ✏️ Replace component by ID with updated JSX/HTML
// ----------------------------------------------------------------------
export const replaceComponentById = (fileContents, componentId, newElement) => {
    const regex = new RegExp(
        `<([A-Za-z0-9]+)([^>]*?)data-component-id=["']${componentId}["'][\\s\\S]*?<\\/\\1>|<([A-Za-z0-9]+)([^>]*?)data-component-id=["']${componentId}["'][^>]*/>`,
        'm'
    );

    return fileContents.replace(regex, newElement);
}


export const convertHtmlStringToJsxString = (htmlString) => {
    // Replace `class=` → `className=`
    let jsxString = htmlString.replace(/\bclass=/g, 'className=');
  
    // Convert style="color:red; background-color:blue;"
    jsxString = jsxString.replace(/style="([^"]+)"/g, (match, cssText) => {
      const styleObj = {};
      cssText.split(';').forEach(rule => {
        const [key, value] = rule.split(':').map(s => s && s.trim());
        if (key && value) {
          const jsKey = key.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
          styleObj[jsKey] = `'${value.replace('!important', '').trim()}'`;
        }
      });
  
      // Convert style object to JSX-style
      const jsxStyle = `{${JSON.stringify(styleObj)
        .replace(/"([^"]+)":/g, '$1:')
        .replace(/"/g, '')}}`;
  
      return `style=${jsxStyle}`;
    });
  
    return jsxString;
  }

export const formatDuration = (ms) => {
    if (typeof ms !== 'number') return '—';
    if (ms > 0 && ms < 1000) return `${(ms / 1000).toFixed(1)} sec`;
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const minuteText =
        minutes > 0
            ? `${minutes} min${minutes === 1 ? "" : "s"}`
            : "";

    const secondText =
        seconds > 0
            ? `${seconds} sec${seconds === 1 ? "" : "s"}`
            : "";

    return [minuteText, secondText].filter(Boolean).join(" ");

};

export const formatDate = (dateString) => {
  if (!dateString) return "Recently";

  const date = new Date(dateString);
  const diff = Math.floor((Date.now() - date) / 1000);

  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;

  const days = Math.floor(diff / 86400);

  if (days === 1) return "1 day ago";
  if (days < 7) return `${days} days ago`;
  if (days < 30) return `${Math.ceil(days / 7)}w ago`;

  return `${Math.floor(days / 30)}mo ago`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "—";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "—";

  const datePart = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const timePart = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return {
    date: datePart,
    time: timePart,
  };
};

/**
 * Compact count for badges: 87 -> "87", 1200 -> "1K", 10500 -> "10K"
 */
export const formatCount = (count) => {
    const n = Number(count);
    if (!Number.isFinite(n) || n < 0) return '';

    if (n >= 1000) {
        const k = Math.floor(n / 1000);
        return n % 1000 === 0 ? `${k}K` : `${k}K+`;
    }

    if (n >= 100) {
        const h = Math.floor(n / 100) * 100;
        return n % 100 === 0 ? String(h) : `${h}+`;
    }

    return String(n);
};